import { isTeamContextHandled } from "../../teamContext/teamSwitchService";
import { Component, createRef } from "react";
import React from "react";
import { Button, IconButton } from "../../design_system/components/Button/Button.jsx";
import { apiAgent } from "../../axiosConfig.js";
import { SelectionControl } from "../../design_system/components/SelectionControls/SelectionControl.jsx";
import Avatar from "../../design_system/components/Avatar/Avatar.jsx";
import { connect } from "react-redux";
import { Popup } from "../../design_system/components/Popup/Popup.jsx";
import { ClickableDropdown } from "../../design_system/components/Dropdown/Dropdown.jsx";
import { DropdownItem } from "../../design_system/components/Dropdown/DropdownItem.jsx";
import { DropdownTrigger } from "../../design_system/components/Dropdown/DropdownTrigger.jsx";
import { DropdownMenu } from "../../design_system/components/Dropdown/DropdownMenu.jsx";
import { Icons } from "../../design_system/components/Icons/Icons.jsx";
import { InputBox } from "../../design_system/components/Input Fields/InputBox.jsx";
import { InputArea } from "../../design_system/components/Input Fields/InputArea.jsx";
import { Badge } from "../../design_system/components/Input Fields/Badge.jsx";
import EmailSuggestionInput from "./_EmailSuggestionInput.jsx";
import { useToast } from "../../design_system/components/Toast/ToastContext.jsx";
import { AnConfirmPopup } from "../cta_utils/AnConfirmPopup.js";
import MenuDots from "../../assets/MenuDots.svg";
import ViewIcon from "../../assets/ViewIcon.svg";
import SuccessTick from "../../assets/Success_tick.svg"
import TopProspectImage from "../../assets/top_prospect.svg";
import GreyArrowDown from "../../assets/GreyArrowDown.svg";
import ShareIcon from "../../assets/share_on_links/share.png";
import PlusCheckbox from "../../assets/Add_Plus_Circle.svg";
import NewOne from "../../assets/new_one.svg";
import { Link } from "react-router-dom";
import { AnInputCheckBox } from "../input_utils/AnInputCheckBox.js";
import { TextHighlighter } from "../utils/textHighlighter.js";
import {
    CommentsDisplay,
    TaggableMentions,
} from "../input_utils/commentMentions.js";
import ConditionalRender from "../../ConditionalRender.js";
import { MENTION_TYPES } from "../utils/AllMentionTypes";
import { LoaderComponent } from "../utils/LoaderComponent.js";
import { ShareOn, getElements } from "../cta_utils/ShareOn.js";
import Mail from "../../assets/share_on_links/mail.png"
import InsightsIcon from "../../assets/increaseGraphIcon.svg"
import { handleNewsImageError } from "../utils/newsImageFallback.js";
import { Tracker, getTrackingPage } from "../utils/mixpanel/tracker.js";
import LinkedinIcon from "../../assets/LinkedinIcon.png"
import SuitcaseIcon from "../../assets/SuitcaseIcon.png"
import Link_Vertical from "../../assets/share_on_links/Link_Vertical.png"
import { isWidthDown } from "../utils/designUtils.js";
import Seemore from "../utils/SeemoreUtils.js";
import CommentDropdown from "../cta_utils/AnCommentDropdown.js";
import ClubbedPost from "./ClubbedPost.jsx";
import { FRONTEND_CONFIG } from "../../configurations/application_config.js";
import AnShortProfile from "../cta_utils/AnShortProfile.js";
import { AnProfileCardWrapper } from "../cta_utils/AnProfileCardWrapper.js";
import { WindfallProfileCardContent } from "../cta_utils/WindfallProfileCard.js";
import { postTypeLabel } from "../utils/AllLabels.js";
import AnToggleButton from "../cta_utils/AnToggleButton.js";
import AnMultipleSuggestionBox from "../input_utils/AnMultipleSuggestionBox.js";
import getApiUrl from "../utils/UrlHelper.js";
import { saveOrRemoveFromProfile } from "./PostFeatures.js";
import Tooltip from "../../design_system/components/ToolTip/ToolTip.jsx";
import AddToCrmPopup from "./_AddToCrmPopup.jsx";
import { SimilarArticlesPopup } from "../views/news_feed/similar_articles.js";
import HighConfidenceContext from "../views/news_feed/high_confidence_context.js";
import { JobUpdateDesc } from "./JobUpdateDesc.js";
import AnMultipleSuggestionInputBox from "../input_utils/AnMultipleSuggestionBox.js";
import Icon from "../utils/Icon.js";
import FlagDetails from "./_FlagDetails.jsx";
import SelectPublishPopup from "../cta_utils/CommonPopups.js/PublishPopups/SelectPublishPopup.jsx";
import { AnConfirmDropdown } from "../cta_utils/AnConfirmDropdown.js";
import { Loader } from "../../design_system/components/Loader.jsx";
import AiSummaryBox from "./AiSummaryBox.jsx";
import { canUsePolicyAction } from "../../utils/access.js";

var popup_lists = {
    share_via_mail_popup: false,
    share_via_popup: false,
    flag_post_popup: false,
    edit_post_popup: false,
    discard_post_popup: false
}

var flag_post_reasons = [
    { key: 'Content', label: 'I don’t find the content relevant enough', value: 'I don’t find the content relevant enough', isOtherReson: false },
    { key: 'Prospect', label: 'I don’t find the prospect relevant enough', value: 'I don’t find the prospect relevant enough', isOtherReson: false },
    { key: 'Source', label: 'I don’t find the source relevant enough', value: 'I don’t find the source relevant enough', isOtherReson: false },
    { key: 'Other', label: 'Other (please specify)', value: '', isOtherReson: true },
]

const shortProfileData = {
    isHovering: true,
    parent: true,
    element: true
}

class Post extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                ...this.props.item,
            },
            expanded: false,
            commentsExpanded: false,
            addComment: false,
            editComment: false,
            comment: {
                markupVal: "",
                plainText: "",
                mentionsList: [],
                comment_id: "",
                prevComment: ""
            },
            shareViaPopup: false,
            share_params: {
                email: "",
                subject: "",
                content: "",
            },
            popup_lists: popup_lists,
            show_dropdown: false,
            tagsList: this.props.tagsList,
            assigneeList: this.props.assigneeList,
            flag_post_reasons: {},
            isLoading: false,
            loader: { addtoCRM: false, commentAction: false },
            isHovering: false,
            parent: null,
            distance_data: 0,
            currentAggregate: null,
            currentTags: this.props.item.tags.map(tag => tag?.id),
            currentAssigns: this.props.item.assigns.map(assign => assign?.id),
            mentionType: "",
            viewersList: [],
            filtersState: this.props.filtersState || {},
            errors: {},
        };
        this.singlePostRef = createRef();
        const crmControlEnabled = this.state.item.post_type === "Post::JobUpdates"
            ? this.props.current_team.displayable_features.display_save_jobs_in_crm
            : this.props.current_team.displayable_features.display_save_news_in_crm;
        this.is_crm_disabled = this.state.item.post_type === "Post::SecFiling" ||
            this.props.current_team.save_to_crm_enabled !== true ||
            crmControlEnabled !== true
    }

    componentDidMount() {
        var prospect = this.state.item.tagged_prospects[0];
        var subject = "";
        if (prospect && prospect.name) {
            let label = this.state.item.post_type === 'Post::JobUpdates' ? "'s Job Update" : this.state.item.post_type === 'Post::SecFiling' ? "'s SEC Filing" : " in news"
            subject = prospect.name + label;
        }
        var email = "";
        if (this.state.item.assigns && this.state.item.assigns.length > 0) {
            email = this.state.item.assigns.filter(item => this.props.current_team.passive_user_ids.indexOf(item.id) === -1).map(item => item.email).join(", ")
        }
        this.setState({
            share_params: {
                email: email,
                subject: subject
            },
        });
        if (this.props.allPostsRef) {
            this.props.allPostsRef.current[this.state.item.id] = this.singlePostRef;
        }
    }
    componentWillUnmount() {
        clearTimeout(this._hoverTimer);
        if (this.props.allPostsRef) {
            delete this.props.allPostsRef.current[this.state.item.id];
        }
    }

    addCommentSection = () => {
        const willExpand = !this.state.commentsExpanded;
        this.setState({
            commentsExpanded: willExpand,
            addComment: willExpand,
            editComment: false,
            comment: {
                markupVal: "",
                plainText: "",
                mentionsList: [],
                comment_id: "",
                prevComment: ""
            }
        });
    };

    editCommentSection = (id, prevComment) => {
        this.setState({
            commentsExpanded: true,
            editComment: !this.state.editComment,
            addComment: true,
            comment: { ...this.state.comment, markupVal: "", comment_id: id, prevComment: prevComment }
        });
    };

    onComment = (event) => {
        event.preventDefault();
        this.setState({
            comment: event.target.value,
        });
    };

    onCommentChange = (event, newVal, plainText, mentionsList) => {
        // event.preventDefault();
        this.setState({
            comment: {
                ...this.state.comment,
                markupVal: newVal,
                plainText: plainText,
                mentionsList: mentionsList,
                prevComment: event.target.value
            },
        });
    };
    addToCrm = () => {
        if (this.is_crm_disabled) return;
        if (this.state.item.post_type === "Post::JobUpdates") {
            // JobUpdate posts always open the popup — even after saving, so users can re-open and review what was synced
            this.setState({ popup_lists: { jobUpdatesCrm: true } })
            return
        }
        if (this.state.item.saved_to_crm) return;
        this.setState({
            loader: { addtoCRM: true },
        });
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/save_to_crm`,
            data: {
            },
        })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        item: { ...this.state.item, saved_to_crm: true },
                        loader: { addtoCRM: false },
                    });
                    this.props.toast.success("Post will be saved to CRM");
                }
                else {
                    this.setState({
                        loader: { addtoCRM: false },
                    });
                    this.props.toast.warning("Prospect not linked to CRM");
                }
            })
            .catch((err) => { });
    }
    addComment = () => {
        if (this.state.comment.markupVal == "") {
            this.addCommentSection();
            return;
        }
        let { current_user } = this.props;
        let mentionsList = this.state.comment.mentionsList.map(m => m.id);
        this.setState({ loader: { ...this.state.loader, commentAction: true } });
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/comment`,
            data: {
                comment: this.state.comment.markupVal,
                mentionsList: mentionsList
            },
        })
            .then((res) => {
                let temp = [...this.state.item.comments, {
                    comment_id: res.data.comment_id,
                    comment: this.state.comment.markupVal,
                    user_id: current_user.id,
                    user_name: current_user.name,
                }]
                this.setState({
                    item: { ...this.state.item, comments: temp },
                    comment: {
                        markupVal: "",
                        plainText: "",
                        mentionsList: [],
                        comment_id: "",
                        prevComment: ""
                    },
                    addComment: true,
                    commentsExpanded: true,
                    loader: { ...this.state.loader, commentAction: false },
                });
            })
            .catch((err) => { this.setState({ loader: { ...this.state.loader, commentAction: false } }); });
    };

    editComment = () => {
        if (this.state.comment.markupVal == "") {
            this.editCommentSection();
            return;
        }
        let { current_user } = this.props;
        let mentionsList = this.state.comment.mentionsList.map(m => m.id);
        this.setState({ loader: { ...this.state.loader, commentAction: true } });
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/edit_comment`,
            data: {
                id: this.state.comment.comment_id,
                edited_comment: this.state.comment.markupVal,
                mentionsList: mentionsList
            },
        })
            .then((res) => {
                let temp2 = [...this.state.item.comments]
                let temp = temp2.map(comment => {
                    if (comment.comment_id == this.state.comment.comment_id)
                        comment.comment = this.state.comment.markupVal
                    return comment
                })
                this.setState({
                    item: { ...this.state.item, comments: temp },
                    comment: {
                        markupVal: "",
                        plainText: "",
                        mentionsList: [],
                        comment_id: "",
                        prevComment: ""
                    },
                    editComment: false,
                    addComment: true,
                    commentsExpanded: true,
                    loader: { ...this.state.loader, commentAction: false },
                });
            })
            .catch((err) => { this.setState({ loader: { ...this.state.loader, commentAction: false } }); });
    };

    deleteComment = (id) => {
        let { current_user } = this.props;
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/delete_comment`,
            data: {
                id: id
            },
        })
            .then((res) => {
                let temp2 = [...this.state.item.comments]
                let temp = temp2.filter(comment => {
                    return comment.comment_id != id
                })
                this.setState({
                    item: { ...this.state.item, comments: temp },
                    comment: {
                        markupVal: "",
                        plainText: "",
                        mentionsList: [],
                        comment_id: "",
                        prevComment: ""
                    },
                    editComment: false,
                    addComment: true,
                    commentsExpanded: true,
                });
            })
            .catch((err) => { });
    };

    addOrRemoveLike = () => {
        let like_status = this.state.item.liked;
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/like_update`,
            params: {
                isAlreadyLiked: like_status,
            },
        })
            .then((res) => {
                this.setState({
                    item: { ...this.state.item, liked: !like_status },
                });
            })
            .catch((err) => { });
    };
    fetchViewDetails = () => {
        this.setState({ isLoading: true });
        apiAgent({
            method: "get",
            url: "/posts/post_view_details",
            params: {
                post_id: this.state.item.id
            }
        }).then(res => {
            this.setState({ isLoading: false, viewersList: res.data.data, item: { ...this.state.item, view_count: res.data.data.length } })
        }).catch(err => this.setState({ isLoading: false }))
    }
    validateShareParams = () => {
        const errors = {};
        const { email } = this.state.share_params;
        if (!email || email.trim() === "") {
            errors.email = "Email is required";
        } else {
            const emails = email.split(',').map(e => e.trim()).filter(Boolean);
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const invalidEmails = emails.filter(e => !emailRegex.test(e));
            if (invalidEmails.length > 0) {
                errors.email = "One or more email IDs are invalid";
            }
        }
        return errors;
    }
    share_via_mail = () => {
        const errors = this.validateShareParams();
        if (Object.keys(errors).length > 0) {
            this.setState({ share_params: { ...this.state.share_params, errors } });
            return;
        }
        // Clean: trim, remove trailing commas, collapse duplicate commas, strip empty entries
        const cleanEmail = this.state.share_params.email
            .split(',').map(e => e.trim()).filter(Boolean).join(', ')
        this.setState({ isLoading: true });
        apiAgent({
            method: "post",
            url: `/post/${this.state.item.id}/share_via_mail`,
            params: { ...this.state.share_params, email: cleanEmail },
        })
            .then((res) => {
                this.setState({
                    isLoading: false,
                });
                this.props.toast.success("Email sent");
                this.close_popups();
            })
            .catch((err) => { });
    };

    share_via_params = (type, value) => {
        const share_params = { ...this.state.share_params };
        share_params[type] = value;
        if (share_params.errors && share_params.errors[type]) {
            const newErrors = { ...share_params.errors };
            delete newErrors[type];
            share_params.errors = newErrors;
        }
        this.setState({ share_params });
    };

    onSavePublishedCallback = (newPostData, response = {}) => {
        this.setState({
            isLoading: false,
            item: { ...response },
            show_dropdown: false
        });
        this.props.toast.success("Post saved successfully");
    };

    discardPost = () => {
        this.openPopup("discard_post_popup");
    };

    confirmDiscard = () => {
        this.setState({ isLoading: true });
        apiAgent({
            method: "post",
            url: "/post/" + this.state.item.id + "/discard",
            data: { page: this.props.currentPage },
        })
            .then((res) => {
                this.setState({ isLoading: false });
                this.close_popups();
                this.props.toast.success("Post deleted successfully");
                if (typeof this.props.discardCallBack === 'function')
                    this.props.discardCallBack(this.state.item.id, res.data)
                else
                    window.location.reload();
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                if (isTeamContextHandled(err)) return;
                this.props.toast.error("Failed to delete post");
            });
    };

    discardPostConfirmPopup = () => {
        return (
            <Popup
                name="Delete Post?"
                handleOnClosePopup={this.close_popups}
                maxWidth={424}
                showHeaderDivider={false}
                showFooterDivider={false}
                primaryAction={{
                    label: 'Delete Post',
                    onClick: this.confirmDiscard,
                    isLoading: this.state.isLoading,
                }}
                secondaryAction={{
                    label: 'Cancel',
                    onClick: this.close_popups,
                }}
            >
                <div className="body-m-semibold color-text-secondary">
                    You’re about to permanently delete this post. This action is irreversible.
                </div>
            </Popup>
        );
    };

    deleteAndUnmapPost = () => {
        this.setState({ popup_lists: { ...this.state.popup_lists, delete_unmap_confirm: true } });
    }

    runDeleteAndUnmapPost = () => {
        this.setState({ popup_lists: {}, isLoading: true });
        apiAgent({
            method: "post",
            url: "/post/" + this.state.item.id + "/delete_and_unmap",
            data: {},
        })
            .then((res) => {
                this.setState({ isLoading: false });
                // 'Prospect Unmapped' is emitted server-side by PostController#delete_and_unmap,
                // so it is recorded even when a tracker is blocked.
                window.location.reload(); //Pending: To be imporved, Maybe resend the prospet list here itself
            })
            .catch((err) => {
                this.setState({ isLoading: false });
            });
    }

    onAddFlagPostReason = () => {
        this.setState({ isLoading: true });
        const flag_reason = this.state.flag_post_reasons.value;

        apiAgent({
            method: "post",
            url: getApiUrl("flag_post", { ":post_id": this.state.item.id }),
            data: {
                flagged_reasons: flag_reason
            },
        })
            .then((res) => {
                this.setState({
                    isLoading: false,
                    show_dropdown: false,
                    flag_post_reasons: {},
                    item: { ...res.data }
                });
                this.props.toast.success(`News article flagged`);
                this.close_popups();
            })
            .catch((err) => {
                if (isTeamContextHandled(err)) {
                    this.setState({ isLoading: false });
                    return;
                }
                const error_message = err?.response?.data?.error || 'Something went wrong';
                this.setState({
                    isLoading: false,
                    show_dropdown: false,
                    flag_post_reasons: {},
                });
                this.props.toast.warning(error_message);
                this.close_popups();
            });
    };

    handleTagsChange = (e) => {
        let val = e.target.value;
        let index = this.state.currentTags.indexOf(val);
        let temp = this.state.currentTags;
        if (index == -1) {
            temp.push(val);
        } else {
            temp.splice(index, 1);
        }
        this.setState({ currentTags: temp });
    };

    handleAssignsChange = (e) => {
        let val = e.target.value;
        let index = this.state.currentAssigns.indexOf(val);
        let temp = this.state.currentAssigns;
        if (index == -1) {
            temp.push(val);
        } else {
            temp.splice(index, 1);
        }
        this.setState({ currentAssigns: temp });
    };

    handleFlagReasonsChange = (reason) => {
        this.setState({
            flag_post_reasons: reason,
        });
    };

    handleClubExpansion = () => {
        this.setState(state => ({ expanded: !state.expanded }))
    }

    openPopup = (name) => {
        var temp_popup_lists = { ...popup_lists };
        temp_popup_lists[name] = true;
        this.setState({ popup_lists: temp_popup_lists });
    };

    close_popups = () => {
        this.setState({
            popup_lists: popup_lists,
            flag_post_reasons: {},
        });
    };

    openViewersDetailPopup = (e) => {
        if (this.state.viewersList.length == 0)
            this.fetchViewDetails()
        this.setState({ popup_lists: { "viewDetailsPopup": true } })

        e.stopPropagation();
    }

    setArticleDescription = (value) => {
        var item = { ...this.state.item };
        item.shared_link.description = value;
        this.setState({ item: item });
    };

    setComponentState = (property, value) => {
        if (shortProfileData[property]) {
            this.setState({ [property]: value });
        }
    }

    setStateFromChild = (payload) => {
        this.setState(payload);
    }

    // Shared base props for all post interaction events; `page`: surface (newsfeed/prospect_profile/single_post/...) the post was on.
    trackPostEvent = (eventName, props = {}) => {
        Tracker.track(eventName, { post_id: this.state.item.id, post_type: postTypeLabel(this.state.item.post_type), prospect_id: this.state.item.tagged_prospects?.[0]?.id, page: getTrackingPage(), ...props });
    }

    canUseNewsAction = (permissionKey) => canUsePolicyAction({
        permissionKey,
        team: this.props.current_team,
    });

    postOptionVisibility = () => {
        const isJobUpdate = this.state.item.post_type === "Post::JobUpdates";
        const isNews = !this.state.item.post_type || this.state.item.post_type === "Post";
        const isStaff = this.props.current_user?.is_super_member === true;

        return {
            canEdit: this.props.checkUserAccess("post_editing") && !isJobUpdate,
            canSaveToProfile: this.canUseNewsAction("news.save_to_profile"),
            canShare: this.canUseNewsAction("news.share"),
            canFlag: this.props.checkUserAccess("post_flagging"),
            canDeleteAndUnmap: this.props.checkUserAccess("post_deletion_and_unmap") && isJobUpdate,
            canDelete: this.props.checkUserAccess("post_deleting") && (isNews || isStaff),
        };
    };

    hasPostOptions = () => Object.values(this.postOptionVisibility()).some(Boolean);

    renderPostOptionsMenu = () => {
        const {
            canEdit,
            canSaveToProfile,
            canShare,
            canFlag,
            canDeleteAndUnmap,
            canDelete,
        } = this.postOptionVisibility();

        return (
            <DropdownMenu customStyle={{ right: 0, left: 'auto', top: '100%', minWidth: '180px', width: 'max-content', marginTop: 4 }}>
                <ConditionalRender if={canEdit}>
                    <DropdownItem
                        IconName="edit"
                        onClick={() => { this.setState({ taggedProspects: this.state.item.tagged_prospects }, () => { this.openPopup("edit_post_popup") }) }}
                    >
                        Edit Post
                    </DropdownItem>
                </ConditionalRender>

                <ConditionalRender if={canSaveToProfile}>
                    <DropdownItem
                        IconName="bookmark"
                        customClasses={this.state.item.is_saved ? "dropdown-item-danger" : ""}
                        onClick={() => saveOrRemoveFromProfile({ setState: this.setStateFromChild, parentProps: this.props, item: this.state.item, toast: this.props.toast })}
                    >
                        {this.state.item.is_saved ? 'Remove from Profile' : 'Save to Profile'}
                    </DropdownItem>
                </ConditionalRender>
                <ConditionalRender if={canShare}>
                    <DropdownItem
                        IconName="share"
                        onClick={() => this.openPopup("share_via_popup")}
                    >
                        Share Post
                    </DropdownItem>
                </ConditionalRender>
                <ConditionalRender if={canFlag}>
                    <DropdownItem
                        IconName="flag"
                        onClick={() => this.openPopup("flag_post_popup")}
                    >
                        Flag Post
                    </DropdownItem>
                </ConditionalRender>
                <ConditionalRender if={canDeleteAndUnmap}>
                    <DropdownItem
                        customClasses="dropdown-item-danger"
                        IconName="delete"
                        onClick={() => this.deleteAndUnmapPost()}
                    >
                        Delete and Unmap
                    </DropdownItem>
                </ConditionalRender>
                <ConditionalRender if={canDelete}>
                    <DropdownItem
                        customClasses="dropdown-item-danger"
                        IconName="delete"
                        onClick={() => this.discardPost()}
                    >
                        Delete Post
                    </DropdownItem>
                </ConditionalRender>
            </DropdownMenu>
        );
    };


    updateReview = () => {
        if (!this.canUseNewsAction("news.review")) return;

        apiAgent({
            method: "post",
            url: getApiUrl("post_review_update", { ":post_id": this.state.item.id }),
            data: {
                mark_unreview: this.state.item.reviewed_at ? true : false
            },
        })
            .then((res) => {
                this.setState({
                    item: { ...this.state.item, reviewed_at: res.data.reviewed_at, reviewed_by: res.data.reviewed_by, reviewer_id: res.data.reviewer_id },
                    updateReviewConfirmDropdown: false
                });
                this.props.toast.success(res.data.reviewed_at ? "Post marked as reviewed" : "Review status removed");
            })
            .catch((err) => { });
    }

    renderSimilarAticles = () => {
        if (!(this.state.item.similar_articles_text && this.state.item.similar_articles_text !== "")) return <></>;
        return (
            <>
                <div className="body-s-semibold color-text-secondary mt-m">
                    Also featured in{" "}
                    {this.state.item.similar_articles_text}{" "}
                    <button
                        type="button"
                        className="body-s-semibold link-default"
                        onClick={() => { this.trackPostEvent("Similar Articles Viewed", { article_id: this.state.item.id }); this.setState({ showSimilarArticlesPopup: true }); }}
                        style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', font: 'inherit' }}
                    >
                        View articles
                    </button>
                </div>
                {this.state.showSimilarArticlesPopup && (
                    <SimilarArticlesPopup
                        articleId={this.state.item.id}
                        masterArticle={this.state.item.shared_link}
                        prospectName={this.state.item.tagged_prospects?.[0]?.name || this.state.item.tagged_prospects?.[0]?.company}
                        onClose={() => this.setState({ showSimilarArticlesPopup: false })}
                    />
                )}
            </>
        )
    }
    handleOnReview = () => {
        if (!this.canUseNewsAction("news.review")) return;

        if (this.state.item.reviewed_at) {
            if (this.props.checkUserAccess('unreview_post') || this.props.current_user.id === this.state.item.reviewer_id)
                this.setState({ updateReviewConfirmDropdown: true })
        }
        else this.updateReview()
    }

    renderPostCTAs = () => {
        if (this.props.simpleView) return <></>
        let can_unreview = this.props.current_team.is_admin || this.props.current_user.id === this.state.item.reviewer_id
        return (
            <div className="flex justify-between items-center newsfeed__post-footer">
                {/*<img src={this.state.item.liked ? LikeFilled : LikeUnfilled} title={this.state.item.liked ? 'Unlike this article' : 'Like this article'} onClick={this.addOrRemoveLike} style={{float: 'left', marginRight: '8px', width: 32, height: 32, cursor: 'pointer'}} />*/}
                <div className="flex items-center flex-row gap-xs">
                    <ConditionalRender if={this.canUseNewsAction("news.comment")}>
                        <Tooltip tooltipText="Comment" placement="bottom-start" showWithoutOverflowing>
                            <Button
                                Type="Ghost"
                                Size="Small"
                                LeadingIcon="comment"
                                ShowLeadingIcon={true}
                                onClick={this.addCommentSection}
                                customIconClassName={this.state.item.comments.length > 0 ? "" : "no-margin"}
                            >
                                {this.state.item.comments.length > 0 ? this.state.item.comments.length : ""}
                            </Button>
                        </Tooltip>
                    </ConditionalRender>
                    <ConditionalRender if={this.canUseNewsAction("news.share")}>
                        <Tooltip tooltipText="Share" placement="bottom" showWithoutOverflowing>
                            <Button
                                Type="Ghost"
                                Size="Small"
                                LeadingIcon="share"
                                ShowLeadingIcon={true}
                                onClick={() => this.openPopup("share_via_mail_popup")}
                                customIconClassName="no-margin"
                            />
                        </Tooltip>
                    </ConditionalRender>
                    <ConditionalRender if={!this.is_crm_disabled && this.canUseNewsAction("news.save_to_crm")}>
                        <Tooltip
                            tooltipText={() => <><span>Saved by </span><span className="body-s-bold">{this.state.item.saved_to_crm_by}</span></>}
                            placement='bottom'
                            showWithoutOverflowing={true}
                            enableTooltip={this.state.item.saved_to_crm_by && this.state.item.saved_to_crm}
                        >
                            <Button
                                Type="Ghost"
                                buttonStyle={{ width: "100%" }}
                                LeadingIconProps={{ style: { fill: this.state.item.saved_to_crm ? 'currentColor' : 'none' } }}
                                Size="Small"
                                LeadingIcon="bookmark"
                                ShowLeadingIcon={true}
                                onClick={this.addToCrm}
                                customIconClassName="no-margin"
                                disabled={this.is_crm_disabled || this.state.item.post_type == "Post::SecFiling"}
                                isLoading={this.state.loader?.addtoCRM}
                            >
                                CRM
                            </Button>
                        </Tooltip>
                    </ConditionalRender>
                </div>
                <div className="flex items-center flex-row gap-xs relative">
                    <Tooltip tooltipText="View" placement="bottom" showWithoutOverflowing>
                        <Button
                            Type="Ghost"
                            Size="Small"
                            LeadingIcon="eye-show"
                            ShowLeadingIcon={true}
                            onClick={this.openViewersDetailPopup}
                            customIconClassName={this.state.item.view_count > 0 ? "" : "no-margin"}
                        >
                            {this.state.item.view_count > 0 ? this.state.item.view_count : ""}
                        </Button>
                    </Tooltip>
                    <ConditionalRender if={!this.state.item.flagged_by && this.canUseNewsAction("news.review")}>
                        <Tooltip
                            tooltipText={() => this.state.item.reviewed_at
                                ? <>
                                    <span className="body-s-semibold">Reviewed by </span>
                                    <span className="body-s-bold">{this.state.item.reviewed_by}<br /></span>
                                    <span className="body-s-semibold"> on </span>
                                    <span className="body-s-bold">{this.state.item.reviewed_at}</span>
                                </>
                                : "Review"}
                            placement='bottom-end'
                            showWithoutOverflowing={true}
                        >
                            <Button
                                Type="Ghost"
                                buttonStyle={{ width: "max-content", cursor: !can_unreview && this.state.item.reviewer_id ? 'default' : 'pointer' }}
                                LeadingIconProps={{ style: { fill: this.state.item.reviewed_at ? 'currentColor' : 'none' } }}
                                Size="Small"
                                LeadingIcon="star-unfilled"
                                ShowLeadingIcon={true}
                                onClick={this.handleOnReview}
                                customIconClassName="no-margin"
                            />
                        </Tooltip>
                        {this.state.updateReviewConfirmDropdown &&
                            <AnConfirmDropdown
                                message='Are you sure you want to mark this post as not reviewed?'
                                btnLabels={{ submitLabel: 'Yes', cancelLabel: 'Cancel' }}
                                onSubmitCallback={() => this.updateReview()}
                                onCancelCallback={() => this.setState({ updateReviewConfirmDropdown: false })}
                                isLoading={false}
                                dropdownStyle={{ marginTop: 'var(--space-s)', top: 'var(--space-2xl)' }}
                            />}
                    </ConditionalRender>
                    {
                        this.state.item.flagged_by && <FlagDetails post={this.state.item} />
                    }
                </div>
            </div>
        )
    }

    renderAddCommentSection = () => {
        if (!this.canUseNewsAction("news.comment")) return null;

        let { current_user } = this.props;
        if (this.state.addComment) {
            return (
                <div className="newsfeed__comment-section">
                    <div className="flex items-center w-full newsfeed__add-comment-section" style={{ backgroundColor: 'var(--color-surface-subtle)', padding: 'var(--space-m)', borderRadius: 'var(--radius-s)' }}>
                        <div className="newsfeed__comment-avatar">
                            <Avatar
                                name={current_user.name}
                                width={40}
                                textStyle={{ fontSize: 16 }}
                            />
                        </div>
                        <TaggableMentions
                            value={this.state.editComment ? "" : this.state.comment.markupVal}
                            onChange={this.onCommentChange}
                            style={{ flex: 1, minWidth: 0, opacity: this.state.editComment ? 0.5 : 1, pointerEvents: this.state.editComment ? 'none' : 'auto' }}
                            placeholder="Add your comment"
                        ></TaggableMentions>
                        <Button
                            onClick={this.addComment}
                            buttonSize="Medium"
                            isLoading={this.state.loader.commentAction}
                            disabled={this.state.loader.commentAction || this.state.editComment}
                        >
                            Post
                        </Button>
                    </div>
                </div>
            );
        } else {
            return <div></div>;
        }
    };

    renderEditCommentSection = () => {
        let { current_user } = this.props;
        if (this.state.editComment) {
            return (
                <div className="flex items-center gap-s" style={{ marginLeft: 'var(--space-s)', width: '100%', marginTop: 0 }}>
                    <TaggableMentions
                        value={this.state.comment.prevComment}
                        onChange={this.onCommentChange}
                        style={{ width: "100%" }} //TODO: provide support for standard classNames as well as inline style in future
                        placeholder={"Add your comment"}
                    ></TaggableMentions>
                    <Button
                        onClick={this.editComment}
                        buttonSize="Medium"
                        isLoading={this.state.loader.commentAction}
                        disabled={this.state.loader.commentAction}
                    >
                        Comment
                    </Button>
                </div>
            );
        } else {
            return <div></div>;
        }
    }
    renderComments = () => {
        let comments = this.state.item.comments;
        if (this.state.item.comments.length > 0) {
            return (
                <>
                    <div>
                        {comments.map((comment, index) => (
                            <div key={comment.comment_id} className="flex items-center newsfeed__comment-row">
                                <div className="flex items-center w-full">
                                    <div>
                                        <Avatar
                                            name={comment.user_name}
                                            width={40}
                                            textStyle={{ fontSize: 16 }}
                                        />
                                    </div>
                                    {this.state.editComment &&
                                        this.state.comment.comment_id == comment.comment_id ? this.renderEditCommentSection()
                                        :
                                        <div className="flex flex-row newsfeed__comment-item">
                                            <div className="flex flex-col">
                                                <div className="body-m-bold color-text-primary">
                                                    {comment.user_id === this.props.current_user.id ? "You" : comment.user_name}
                                                </div>
                                                <CommentsDisplay markupedText={comment.comment} typographyClass="body-s-semibold color-text-secondary"></CommentsDisplay>
                                            </div>
                                        </div>

                                    }
                                </div>
                                <ConditionalRender if={this.canUseNewsAction("news.comment") && !this.state.editComment && (this.props.current_user.id === comment.user_id || this.props.current_team.is_admin)}>
                                    <CommentDropdown
                                        commentID={comment.comment_id}
                                        prevComment={comment.comment}
                                        value={this.state.comment.markupVal}
                                        canEdit={this.props.current_user.id === comment.user_id}
                                        canDelete={this.props.current_user.id === comment.user_id || this.props.current_team.is_admin}
                                        editCommentSection={this.editCommentSection}
                                        deleteComment={this.deleteComment}
                                    />
                                </ConditionalRender>
                            </div>
                        ))}
                    </div>
                </>
            );
        } else return <div></div>;
    };

    renderCommentsSection = () => {
        return (
            <>
                {this.renderAddCommentSection()}
                {this.state.commentsExpanded && this.renderComments()}
            </>
        )
    }

    editPostPopup = () => {
        return (
            <SelectPublishPopup
                post_type={this.state.item.post_type}
                labels={{ popupName: "Edit Post", submitBtn: "Edit Post" }}
                onCloseCallback={() => this.close_popups()}
                aggregateData={{
                    prospects: this.state.taggedProspects,
                    sharable_article: { ...this.state.item.shared_link },
                    mentioned_for: this.state.item.mentioned_for,
                }}
                onPublishCallback={this.onSavePublishedCallback}
                mode="edit"
                publish_url={getApiUrl("update_post", { ":id": this.state.item.id })}
            />
        )
    };

    openShareForAssignee = (assign) => {
        if (!this.canUseNewsAction("news.share")) return;

        this.setState({
            share_params: {
                ...this.state.share_params,
                email: assign.email,
            }
        }, () => this.openPopup("share_via_mail_popup"));
    }

    openShareForAllAssignees = () => {
        if (!this.canUseNewsAction("news.share")) return;

        const email = this.state.item.assigns
            .filter(item => this.props.current_team.passive_user_ids.indexOf(item.id) === -1)
            .map(item => item.email).join(", ");
        this.setState({
            share_params: {
                ...this.state.share_params,
                email: email,
            }
        }, () => this.openPopup("share_via_mail_popup"));
    }

    postNotifySection = () => {
        const assigns = this.state.item.assigns;
        if (!assigns || assigns.length === 0) return null;

        const maxVisible = 3;
        const visible = assigns.slice(0, maxVisible);
        const overflow = assigns.length - maxVisible;

        return (
            <div className="flex items-center">
                <span className="body-s-semibold newsfeed__item-subtitle">Assigned to</span>
                <ClickableDropdown>
                    <DropdownTrigger IsIconVisible={false} ShowHover={false} customStyle={{ padding: 0, cursor: 'pointer' }}>
                        <div className="newsfeed__assignees">
                            {visible.map((assign) => (
                                <Avatar key={assign.id} name={assign.name} width={24} textClassName="support-m-caps" />
                            ))}
                            {overflow > 0 && (
                                <span className="newsfeed__assignees-overflow body-s-bold">
                                    +{overflow}
                                </span>
                            )}
                        </div>
                    </DropdownTrigger>
                    <DropdownMenu customStyle={{ width: 240, right: 0, left: 'auto', padding: 'var(--space-xs)' }}>
                        <div className="newsfeed__assignees-header body-m-semibold mb-m">Assigned to</div>
                        {assigns.map((assign) => (
                            assign.name && (
                                <DropdownItem key={assign.id} customClasses="mb-s" customStyle={{ padding: 0 }} onClick={this.canUseNewsAction("news.share") ? () => this.openShareForAssignee(assign) : undefined}>
                                    <div className="flex items-center gap-s">
                                        <Avatar name={assign.name} width={40} textClassName="body-l-semibold" />
                                        <span className="body-m-bold truncate color-text-primary">{assign.name}</span>
                                    </div>
                                </DropdownItem>
                            )
                        ))}
                        <div className="newsfeed__assignees-divider"></div>
                        <ConditionalRender if={this.canUseNewsAction("news.share")}>
                            <DropdownItem onClick={() => this.openShareForAllAssignees()}>
                                <div className="flex items-center gap-s mb-xs">
                                    <Icons name="share" size={16} />
                                    <span className="body-m-semibold">Share Post</span>
                                </div>
                            </DropdownItem>
                        </ConditionalRender>
                    </DropdownMenu>
                </ClickableDropdown>
            </div>
        );
    }

    viewDetailsPopup = () => {
        const view_count = this.state.item.view_count;
        return (
            <Popup
                name={`${view_count} view${view_count > 1 ? "s" : ""}`}
                handleOnClosePopup={() => this.close_popups()}
                maxWidth={420}
                customPopupStyle={{ maxHeight: 480 }}
                show={this.state.popup_lists.viewDetailsPopup}
            >
                <ConditionalRender if={this.state.isLoading}>
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-l) 0' }}>
                        <Loader isLoading={this.state.isLoading}></Loader>
                    </div>
                </ConditionalRender>
                <ConditionalRender if={!this.state.isLoading}>
                    {view_count === 0 ?
                        (
                            <div className="body-l-bold newsfeed__section-title" style={{ margin: 'var(--space-5xl) auto', textAlign: 'center' }}>
                                You are the first to view this post
                            </div>
                        ) :
                        (
                            <div className="my-m mx-0">
                                {this.state.viewersList.map((viewer, index) => (
                                    <div className="flex items-center w-full newsfeed__prospect-container" key={viewer.id} style={{ marginTop: index === 0 ? 0 : 'var(--space-l)' }}>
                                        <div className="newsfeed__prospect-info flex items-center gap-s">
                                            <Avatar width={40} name={viewer.name}></Avatar>
                                            <div className="body-m-bold newsfeed__item-title">
                                                {viewer.name}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </ConditionalRender>
            </Popup>
        )
    }

    handleHover = (event) => {
        clearTimeout(this._hoverTimer);
        const loginHeader = document.querySelector(".header") || document.querySelector(".login_header");
        const element = event.target;

        let id = element.parentElement.id === ("NameText" + this.state.item.id) ? "NameText" + this.state.item.id : "Avatar" + this.state.item.id;
        let outermostDiv = document.getElementById(id);

        if (element && loginHeader) {
            const elementRect = element.getBoundingClientRect();
            const outermostRect = outermostDiv.getBoundingClientRect();
            const loginHeaderRect = loginHeader.getBoundingClientRect();

            this.setComponentState("element", { hoverDiv: outermostRect, scrollY: window.scrollY, loginHeaderRect: loginHeaderRect });

            const top_distance = elementRect.top - loginHeaderRect.bottom;
            const bottom_distance = window.innerHeight - elementRect.bottom;

            let distance_data = this.state.parent === "NameText"
                ? { dTop: top_distance + 4, dBottom: bottom_distance }
                : { dTop: top_distance, dBottom: bottom_distance };

            this._hoverTimer = setTimeout(() => {
                this.setState({
                    distance_data,
                    isHovering: true
                });
            }, 250);
        }
    }

    renderProspect = () => {
        const job_update = this.state.item;
        let { current_user } = this.props;
        const { shortProfileFields } = this.context || { shortProfileFields: { prospectFields: [], fieldsFetched: false } };
        let prospectFields = [], fieldsFetched = false;
        if (shortProfileFields) {
            prospectFields = shortProfileFields.prospectFields;
            fieldsFetched = shortProfileFields.fieldsFetched;
        }

        if (this.state.item.tagged_prospects.length > 0) {
            const [tagged_prospect] = this.state.item.tagged_prospects;
            const name = tagged_prospect.name || tagged_prospect.company;
            return (
                <>
                    {/* TODO: Fix article insight */}
                    <ConditionalRender if={tagged_prospect.article_insight}>
                        <div className="flex items-center gap-s newsfeed__insights-banner">
                            <img src={InsightsIcon} style={{ width: 'var(--icon-size-16)' }} />
                            <span className="support-s-caps newsfeed__post-meta">{tagged_prospect.article_insight}</span>
                            <Link to={`/prospect_articles/${tagged_prospect.id}`}
                                className="link-default body-s-bold newsfeed__link">View</Link>
                        </div>
                    </ConditionalRender>
                    <div className="flex justify-between items-center w-full">
                        <div className="flex items-center w-full newsfeed__prospect-container">
                            <div className="newsfeed__prospect-info">
                                <Link
                                    to={{
                                        pathname: "/prospects/" + tagged_prospect.id,
                                        state: { filtersState: this.state.filtersState, from: window.location.pathname }
                                    }}
                                    className="newsfeed__link no-hover-underline no-underline self-center flex items-center"
                                >
                                    <div id={"Avatar" + this.state.item.id} onMouseOver={(event) => { this.setState({ parent: "Avatar" }); this.handleHover(event); }}
                                        onMouseLeave={() => { clearTimeout(this._hoverTimer); this.setComponentState("isHovering", false); }}
                                    >
                                        <Avatar
                                            width={40}
                                            name={name}
                                            textStyle={{ textDecoration: 'none' }}
                                            profile_image={tagged_prospect?.profile_image}
                                        />
                                    </div>
                                </Link>
                                {this.state.parent === "Avatar" && (prospectFields && prospectFields.length > 0) &&
                                    <AnShortProfile
                                        prospect={tagged_prospect}
                                        isHovering={this.state.isHovering}
                                        setComponentState={this.setComponentState}
                                        parent={this.state.parent}
                                        element={this.state.element}
                                        parentDistance={this.state.distance_data}
                                        post={this.state.item}
                                    />
                                }

                                <div className="flex flex-col flex-1 min-w-0" onMouseLeave={() => { clearTimeout(this._hoverTimer); if (this.state.parent === "NameText") this.setState({ isHovering: false }); }}>
                                    <div className="flex items-center gap-s newsfeed__post-meta-row">
                                        <div id={"NameText" + this.state.item.id} onMouseOver={(event) => { this.setState({ parent: "NameText" }); this.handleHover(event); }}
                                            style={{ overflow: "hidden", flexShrink: 1, maxWidth: "60%" }}
                                        >
                                            <div style={{
                                                textDecoration: "none",
                                                overflow: "hidden"
                                            }}>
                                                <Link
                                                    to={{
                                                        pathname: "/prospects/" + tagged_prospect.id,
                                                        state: { filtersState: this.state.filtersState, from: window.location.pathname }
                                                    }}
                                                    className="body-m-bold block no-underline newsfeed__post-title no-hover-underline"
                                                >
                                                    <div className="truncate w-full">
                                                        {name}
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        <ConditionalRender if={this.state.item.post_type === "Post::JobUpdates"}>
                                            <div className="items-centered">
                                                <a href={job_update.linkedin_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="newsfeed__linkedin-link"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <Icons name="linkedin" size="16" className="icon-subtle" />
                                                </a>
                                            </div>
                                        </ConditionalRender>
                                        <ConditionalRender if={this.props.current_team.windfall_enrichment_enabled}>
                                            <div className="pl-s">
                                                <AnProfileCardWrapper
                                                    DesignComponent={WindfallProfileCardContent}
                                                    prospect={tagged_prospect}
                                                    portalId="hover_card"
                                                    triggerIcon={{ open: "WindfallLogo", closed: "WindfallLogo" }}
                                                    placement="bottom"
                                                    cardStyle={{ maxHeight: '396px', width: 360 }}
                                                />
                                            </div>
                                        </ConditionalRender>
                                        <ConditionalRender if={this.state.item.post_type !== "Post::JobUpdates" && this.state.item.tags?.length > 0}>
                                            <div className="min-w-0">
                                                <Tooltip
                                                    tooltipText={() => this.state.item.tags?.map((tag, i) => <span key={tag.id} className="uppercase">{tag.name}{((i + 1) !== this.state.item.tags?.length) ? (i + 1) % 3 === 0 ? <br /> : ", " : ""}</span>)}
                                                    placement='bottom'
                                                    cursorPointerOnOverflow={true}
                                                    wrapperStyle={{cursor: 'default'}}
                                                >
                                                    <div className="newsfeed__post-meta support-s-caps truncate" style={{ maxWidth: 200, paddingRight: "var(--space-s)", marginTop: 0 }}>
                                                        {this.state.item.tags?.map((tag) => <span key={tag.id} className="mr-s">{tag.name}</span>)}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </ConditionalRender>
                                    </div>
                                    {this.state.parent === "NameText" && prospectFields.length > 0 &&
                                        <AnShortProfile
                                            prospect={tagged_prospect}
                                            isHovering={this.state.isHovering}
                                            setComponentState={this.setComponentState}
                                            parent={this.state.parent}
                                            element={this.state.element}
                                            parentDistance={this.state.distance_data}
                                            post={this.state.item}
                                        />
                                    }
                                    <ConditionalRender if={this.state.item.tagged_prospects[0].name}>
                                        <Tooltip
                                            tooltipText={() => this.state.item.tagged_prospects[0].designation}
                                            placement='bottom'
                                        >
                                            <div className="newsfeed__item-subtitle body-s-semibold truncate pr-s">
                                                {this.state.item.tagged_prospects[0].designation}
                                            </div>
                                        </Tooltip>
                                    </ConditionalRender>
                                </div>
                            </div>
                            <div className="flex items-center flex-row gap-m relative">
                                {!isWidthDown(this.props.windowDimensions.width, "md") && !this.props.simpleView && this.postNotifySection()}
                                <div className="flex items-center gap-s">
                                    <div className="body-s-semibold newsfeed__item-subtitle">
                                        <Tooltip
                                            placement='bottom-end'
                                            tooltipText={this.state.item.formatted_created_at}
                                            showWithoutOverflowing
                                            wrapperStyle={{cursor: 'pointer'}}
                                        >
                                            {this.state.item.created_at_time}
                                        </Tooltip>
                                    </div>
                                    {!this.props.simpleView && this.hasPostOptions() &&
                                        (
                                            <ClickableDropdown>
                                                <DropdownTrigger ShowHover={false} IsIconVisible={false} customStyle={{ padding: 0, cursor: 'pointer', alignItems: "center" }}>
                                                    <IconButton
                                                        Size="ExtraSmall"
                                                        Type="Tertiary"
                                                        IconName="vertical-ellipsis"
                                                        ariaLabel="Toggle Options"
                                                    />
                                                </DropdownTrigger>
                                                {this.renderPostOptionsMenu()}
                                            </ClickableDropdown>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        } else return <div></div>;
    };

    shareViaMailPopup = () => {
        const title = `Share ${postTypeLabel(this.state.item.post_type)}`;

        return (
            <Popup
                name={title}
                handleOnClosePopup={() => this.close_popups()}
                maxWidth={480}
                primaryAction={{
                    label: "Send Email",
                    onClick: () => this.share_via_mail(),
                    isLoading: this.state.isLoading
                }}
                secondaryAction={{
                    label: "Cancel",
                    onClick: () => this.close_popups()
                }}
            >
                <EmailSuggestionInput
                    value={this.state.share_params.email}
                    onChange={(val) => this.share_via_params("email", val)}
                    placeholder="Search names or paste in emails below, separated by commas"
                    error={this.state.share_params.errors?.email}
                    helperText={this.state.share_params.errors?.email}
                    showHelperText={true}
                    customStyle={{ marginBottom: "var(--space-l)", marginTop: "var(--space-m)" }}
                />

                <InputBox
                    Size="Large"
                    label="Subject of the email"
                    showLabel={true}
                    value={this.state.share_params.subject}
                    handleOnChange={(e) => this.share_via_params("subject", e.target.value)}
                    placeholder="Placeholder"
                    customStyle={{ marginBottom: "var(--space-l)" }}
                />

                <InputArea
                    label="Message"
                    showLabel={true}
                    value={this.state.share_params.content}
                    handleOnChange={(e) => this.share_via_params("content", e.target.value)}
                    placeholder="Placeholder"
                    resizable
                />
                <div className="support-m color-text-tertiary mb-m">
                    {`${postTypeLabel(this.state.item.post_type)} snippet will be automatically added`}
                </div>
            </Popup>
        );
    };

    Socials = () => {
        const sharable_url = this.state.item.shared_link?.url;
        const params = {
            "Facebook": {
                url: sharable_url,
                title: this.state.item.shared_link?.title,
                summary: this.state.item.shared_link?.description
            },
            "LinkedIn": {
                url: sharable_url,
                title: this.state.item.shared_link?.title,
                summary: this.state.item.shared_link?.description
            },
            "Twitter": {
                url: sharable_url,
                text: this.state.item.shared_link?.title || this.state.item.shared_link?.description
            }
        }
        const SUB_SECTIONS = getElements(params);
        return Object.keys(SUB_SECTIONS).map((key) => (
            <div key={key} style={{ display: "contents" }} onClick={() => this.trackPostEvent("Post Shared", { share_channel: key.toLowerCase() })}>
                <ShareOn
                    icon={SUB_SECTIONS[key].icon}
                    url={SUB_SECTIONS[key].url}
                    text={key}
                    label={key}
                />
            </div>
        ))
    }
    shareViaPopup = () => {
        return (
            <Popup
                name="Share via..."
                handleOnClosePopup={() => this.close_popups()}
                maxWidth={240}
                show={this.state.popup_lists.share_via_popup}
                customContentStyle={{ padding: "0 var(--space-m)" }}
            >
                <div style={{ padding: 'var(--space-m) 0' }}>
                    {this.state.item.post_type !== "Post::JobUpdates" && this.Socials()}
                    <DropdownItem
                        customStyle={{ padding: "var(--space-s) var(--space-m)" }}
                        IconName="mail"
                        onClick={() => { this.openPopup("share_via_mail_popup") }}
                    >
                        Email
                    </DropdownItem>
                    <DropdownItem
                        customStyle={{ padding: "var(--space-s) var(--space-m)" }}
                        IconName="copy-link"
                        onClick={() => {
                            navigator.clipboard.writeText(FRONTEND_CONFIG.WEB_URL + "post/" + this.state.item.id)
                            this.trackPostEvent("Post Shared", { share_channel: "copy_link" });
                            this.close_popups();
                            this.setState({ show_dropdown: false })
                            this.props.toast.success("Link Copied");
                        }}
                    >
                        Copy Link
                    </DropdownItem>
                </div>
            </Popup>
        )
    }

    flagPostPopup = () => {
        return (
            <Popup
                name="Flag Post"
                handleOnClosePopup={this.close_popups}
                maxWidth={430}
                primaryAction={{
                    label: "Submit",
                    onClick: this.onAddFlagPostReason,
                    isLoading: this.state.isLoading,
                    disabled: !this.state.flag_post_reasons?.value
                }}
                secondaryAction={{
                    label: "Cancel",
                    onClick: this.close_popups
                }}
            >
                <div className="newsfeed__flag-reason-container">
                    {flag_post_reasons.map((reason, index) => {
                        let is_chosen = this.state.flag_post_reasons.key === reason.key
                        return (
                            <div key={index} style={{ marginBottom: index === flag_post_reasons.length - 1 ? 'var(--space-2xs)' : 'var(--space-s)' }}>
                                <SelectionControl
                                    type="radio"
                                    label={reason.label}
                                    name="flag_reason"
                                    value={reason.key}
                                    checked={is_chosen}
                                    onChange={() => { this.handleFlagReasonsChange(reason) }}
                                />
                                <ConditionalRender if={this.state.flag_post_reasons.isOtherReson && is_chosen}>
                                    <InputArea
                                        placeholder="Please mention the reason"
                                        value={this.state.flag_post_reasons.value}
                                        handleOnChange={(e) => {
                                            this.setState(prevState => ({
                                                flag_post_reasons: {
                                                    ...prevState.flag_post_reasons,
                                                    value: e.target.value,
                                                }
                                            }));
                                        }}
                                        rows={3}
                                        customStyle={{ marginTop: 'var(--space-s)', paddingLeft: 'var(--space-l)' }}
                                    />
                                </ConditionalRender>
                            </div>
                        );
                    })}
                </div>
            </Popup>
        )
    }

    renderTypePill = () => {
        if (this.state.filtersState?.postType !== 'all') return null
        const tabsEnabled = this.props.current_user?.is_super_member || this.props.current_team.feed_job_updates_enabled || this.props.current_team.sec_filings_enabled;
        if (!tabsEnabled) return null
        const postType = this.state.item.post_type
        let badgeType, label, icon
        switch (postType) {
            case 'Post::JobUpdates':
                badgeType = 'Job'; label = 'Job update'; icon = 'suitcase'; break
            case 'Post::SecFiling':
                badgeType = 'Sec'; label = 'SEC Filing'; icon = 'notes'; break
            default:
                badgeType = 'News'; label = 'News result'; icon = 'edit'
        }
        return (
            <div className="newsfeed__post-type-pill">
                <Badge type={badgeType} label={label} ShowLeadingIcon LeadingIcon={icon} fontClass="support-m-semibold" />
            </div>
        )
    }

    renderNewsPost = () => {
        const tabsEnabled = this.props.current_user?.is_super_member || this.props.current_team.feed_job_updates_enabled || this.props.current_team.sec_filings_enabled;
        const hasPill = this.state.filtersState?.postType === 'all' && tabsEnabled
        return (
            <div className={`newsfeed__post-card${hasPill ? '' : ' newsfeed__post-card--no-pill'}`}>
                <div className="px-xl">
                    {this.renderProspect()}
                    {this.renderTypePill()}
                    <ConditionalRender if={this.state.item.clubbed_posts_count > 0}>
                        <div className="mt-l">
                            <ClubbedPost item={this.state.item} expanded={this.state.expanded}
                                toggleExpansionCallback={this.handleClubExpansion}
                                renderSimilarArticles={this.renderSimilarAticles}
                                renderCTAs={this.renderPostCTAs}
                                renderCommentsSection={this.renderCommentsSection}
                            />
                        </div>
                    </ConditionalRender>
                </div>
                <ConditionalRender if={this.state.item.clubbed_posts_count === 0}>
                    <div className="px-xl">
                        <ConditionalRender if={this.state.item.post_type !== 'Post::SecFiling' && (this.state.item.mentioned_for || this.state.item.interests)}>
                            <div className="flex items-center gap-m newsfeed__post-meta-row color-text-secondary body-m-semibold mt-m mb-s">
                                <ConditionalRender if={this.state.item.mentioned_for}>
                                    <span>Mentioned for: <span className="color-text-primary">{this.state.item.mentioned_for}</span></span>
                                </ConditionalRender>
                                <ConditionalRender if={this.state.item.mentioned_for && this.state.item.interests}>
                                    <span aria-hidden="true" className="color-text-tertiary">·</span>
                                </ConditionalRender>
                                <ConditionalRender if={this.state.item.interests}>
                                    <span>{this.state.item.interests}</span>
                                </ConditionalRender>
                            </div>
                        </ConditionalRender>
                        <ConditionalRender if={this.state.item.post_type === 'Post::SecFiling'}>
                            <div className='mt-m mb-s flex flex-col gap-xs'>
                                {this.state.item.sec_category && <div className='body-s-semibold color-text-secondary'><span className="body-s-bold">Category:</span><span> {this.state.item.sec_category}</span> </div>}
                                {this.state.item.ai_summary && <AiSummaryBox aiSummary={this.state.item.ai_summary} />}
                            </div>
                        </ConditionalRender>
                        <a
                            href={this.state.item.shared_link.url}
                            target="_blank"
                            className="newsfeed__post-body"
                            onClick={() => this.trackPostEvent("Article Link Clicked", { source: this.state.item.shared_link.source })}
                        >
                            {this.state.item.shared_link.image_url &&
                                <img
                                    src={this.state.item.shared_link.image_url}
                                    className="newsfeed__post-image"
                                    onError={handleNewsImageError}
                                />
                            }
                            <div className="overflow-hidden">
                                <TextHighlighter
                                    contentString={
                                        this.state.item.shared_link.title
                                    }
                                    toMatch={[
                                        ...[this.state.item.tagged_prospects?.[0]?.name, this.state.item.tagged_prospects?.[0]?.company],
                                        { toMatchText: this.props.searchTerm, highlightCustomStyle: { background: "var(--color-highlighter-color)", textTransform: "capitalize", borderRadius: 4 } }
                                    ]}
                                    typography={{ className: "block no-underline body-m-bold newsfeed__post-title" }}
                                />
                                <ConditionalRender if={this.state.item.post_type !== 'Post::SecFiling'}>
                                    <Seemore
                                        short_description={this.state.item.shared_link.short_description}
                                        description={this.state.item.shared_link.description}
                                        person_name={[this.state.item.tagged_prospects?.[0]?.name, this.state.item.tagged_prospects?.[0]?.company]}
                                        searchTerm={this.props.searchTerm}
                                    >
                                    </Seemore>
                                </ConditionalRender>
                                <div
                                    className="support-m color-text-secondary mt-s"
                                >
                                    <Link to={"/news_source/" + this.state.item.shared_link.source + "/feed"} className="link-default support-m">{this.state.item.shared_link.source}</Link>{" "}
                                    {this.state.item.shared_link.published_at
                                        ? `| ${this.state.item.shared_link.published_at}`
                                        : ""}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="px-xl">
                        {this.renderSimilarAticles()}
                    </div>
                    {!this.props.simpleView && (<div className="newsfeed__divider mt-l"></div>)}
                    <div className="px-xl">
                        {this.renderPostCTAs()}
                        {this.renderCommentsSection()}
                    </div>
                </ConditionalRender >
                {/* <ConditionalRender if={this.props.checkUserAccess('display_omf_tags') && this.props.current_team.omf_enabled}>
                    <div className="flex-container-space-between post-padding mt-l">
                        {this.state.item.openai_tags && 
                        <div>
                            <span className="support-s-caps newsfeed__post-meta">Tags: </span>
                            {
                                this.state.item.openai_tags.map(k => (
                                    <span className="body-m-bold newsfeed__item-title ml-m" key={k}>{k}</span>
                                ))
                            }
                        </div>}
                    </div>
                </ConditionalRender> */}
            </div >
        )
    }
    renderJobUpdate = () => {
        const job_update = this.state.item;
        if (this.state.item.tagged_prospects.length > 0) {
            var [tagged_prospect] = this.state.item.tagged_prospects;
            var name = tagged_prospect.name;
        }
        const tabsEnabled = this.props.current_user?.is_super_member || this.props.current_team.feed_job_updates_enabled || this.props.current_team.sec_filings_enabled;
        const hasPill = this.state.filtersState?.postType === 'all' && tabsEnabled
        return (
            <div className={`newsfeed__post-card${hasPill ? '' : ' newsfeed__post-card--no-pill'}`}>
                <div className="px-xl">
                    {this.renderProspect()}
                    {this.renderTypePill()}
                </div>
                <div className="px-xl pt-m">
                    <JobUpdateDesc job_update={{ ...job_update, name: name }} searchTerm={this.props.searchTerm} />
                </div>
                <div className="newsfeed__divider mt-m"></div>
                <div className="px-xl">
                    {this.renderPostCTAs()}
                </div>
                <div className="px-xl">
                    {this.renderCommentsSection()}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div ref={this.singlePostRef} trackid={this.state.item.id}>
                {
                    this.state.item.post_type === "Post::JobUpdates" ?
                        this.renderJobUpdate() : this.renderNewsPost()
                }
                {this.canUseNewsAction("news.share") && this.state.popup_lists.share_via_mail_popup &&
                    this.shareViaMailPopup()}
                {this.canUseNewsAction("news.share") && this.state.popup_lists.share_via_popup &&
                    this.shareViaPopup()}

                {this.state.popup_lists.flag_post_popup &&
                    this.flagPostPopup()}
                {this.state.popup_lists.edit_post_popup &&
                    this.editPostPopup()}
                {
                    this.state.popup_lists.viewDetailsPopup && this.viewDetailsPopup()
                }
                {!this.is_crm_disabled && this.canUseNewsAction("news.save_to_crm") && this.state.popup_lists.jobUpdatesCrm && (<AddToCrmPopup post={this.state.item} prospect={this.state.item.tagged_prospects[0]} handleOnClosePopup={() => this.setState({ popup_lists: {} })} onFinish={(payload) => this.setState({ ...payload })} />)}
                {this.state.popup_lists.discard_post_popup && this.discardPostConfirmPopup()}
                {this.state.popup_lists.delete_unmap_confirm && (
                    <AnConfirmPopup
                        name="Delete and unmap post"
                        confirm_message="Are you sure you want to delete and unmap this post?"
                        btnLabels={{ submitLabel: 'Delete', cancelLabel: 'Cancel' }}
                        onSubmitCallback={this.runDeleteAndUnmapPost}
                        onCancelCallback={() => this.setState({ popup_lists: {} })}
                    />
                )}
            </div>
        );
    }
}

// TODO: When converted to functional component then use useToast hook
const withToast = (WrappedComponent) => {
    return (props) => {
        const toast = useToast();
        return <WrappedComponent {...props} toast={toast} />;
    };
};

const mapStateToProps = function (state) {
    return {
        current_user: state.current_user.user,
        current_team: state.current_team.team,
    };
};
Post.contextType = HighConfidenceContext;
export default connect(mapStateToProps)(withToast(Post));

// TODO: CONVERT TO FUNCTIONAL COMPONENT AND USE USESELECTOR HOOK FOR current_user and current_team
